import React, { memo } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import { ConfromBoxMain } from "./Styles";
// import DialogTitle from "@mui/material/DialogTitle";

const index = ({ open = false, onClose = () => {}, setConfirm = () => {} }) => {
  return (
    <>
      <Dialog open={open} onClose={onClose}>
        {/* <DialogTitle>{title}</DialogTitle> */}
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this item?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <ConfromBoxMain>
            <Button onClick={onClose} color="primary" className="cancel_button">
              Cancel
            </Button>
            <Button
              onClick={setConfirm}
              color="primary"
              autoFocus
              className="confirm_button"
            >
              Confirm
            </Button>
          </ConfromBoxMain>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default memo(index);
